import React from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Box, Typography, Container, Paper, Button } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import PublicHeader from '../../Components/Header/PublicHeader';

const PublicOrderError: React.FC = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const errorMessage = searchParams.get("message") || 'エラーが発生しました';

    const handleBack = () => {
        navigate(-1);
    };

    return (
        <>
            <PublicHeader />
            <Container maxWidth="sm">
                <Box
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    alignItems="center"
                    minHeight="70vh"
                    py={4}
                >
                    <Paper
                        elevation={3}
                        sx={{
                            p: 4,
                            width: '100%',
                            textAlign: 'center',
                            borderRadius: 2
                        }}
                    >
                        <ErrorOutlineIcon
                            color="error"
                            sx={{
                                fontSize: 64,
                                mb: 2
                            }}
                        />
                        <Typography
                            variant="h5"
                            color="error"
                            gutterBottom
                            sx={{
                                fontWeight: 'bold',
                                mb: 3
                            }}
                        >
                            {errorMessage}
                        </Typography>
                        <Button
                            variant="contained"
                            color="primary"
                            startIcon={<ArrowBackIcon />}
                            onClick={handleBack}
                            sx={{ mt: 2 }}
                        >
                            前のページに戻る
                        </Button>
                    </Paper>
                </Box>
            </Container>
        </>
    );
};

export default PublicOrderError;
